/**
 * @file Select Account Identity container.
 */

import { connect } from 'react-redux';

import SelectAccountIdentity from '../../components/discover/SelectAccountIdentity';
import { getUploadedPhotoByIdentity } from '../../util/photo-upload';
import { openModal } from '../../actions/modal-actions';

const mapStateToProps = ({ photoUploads, discoverAlbumFolder }, ownProps) => ({
  uploadedPhoto: getUploadedPhotoByIdentity(
    photoUploads.photos,
    ownProps.identity,
  ),
  selectedIdentities: discoverAlbumFolder.identities,
});

const mapDispatchToProps = {
  openModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectAccountIdentity);
